
import Icon from '@/components/Icon.vue'
import { showAlert } from '@/components/popup/popup'
import { translate } from '@/i18n'
import Switch from '@/modules/membership/signal/components/Switch.vue'
import TheLimitRangeInput from '@/modules/trade/components/TheLimitRangeInput.vue'
import Order from '@/modules/trade/Order'
import { useOrderLimit } from '@/modules/trade/trade'
import Pic from '@/components/Pic.vue'
import { computed, defineComponent, inject, shallowRef, unref } from 'vue'

const MIN = 10

export default defineComponent({
  name: 'TheStopLoss',
  components: {
    Pic,
    Icon,
    TheLimitRangeInput,
    Switch,
  },
  props: {
    showDistance: Boolean,
  },
  setup () {
    const order = inject('order') as Order
    const showExplain = shallowRef(false)

    const { percent, limit, profit, estQuote, distance } = useOrderLimit(unref(order.stopLoss.value), -1)
    const noLimit = computed(() => percent.value === 0)

    const toggleLimit = (state: boolean) => {
      limit(state ? MIN : 0)
    }

    return {
      showExplain,
      MIN,
      order,
      noLimit,
      percent,
      profit,
      estQuote,
      distance,
      limit,
      toggleLimit,
      exceed () {
        showAlert(translate('toast_16'))
      },
    }
  },
})
